import clsx from 'clsx';
import * as React from 'react';

interface SectionTitleProps {
	title?: string;
	className?: string;
}

export const SectionTitle = ({ title, className }: SectionTitleProps) => (
  <div
    className={clsx(
      className,
      'border-b border-gray-300 print:border-b-0',
      title && 'pt-3 mb-3',
      !title && 'my-3'
    )}
  >
    <h2 className="text-2xl font-bold tracking-tight text-gray-800">{title}</h2>
  </div>
);
